/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

// Get the package.json version to display in the dashboard
import packageJson from '../../../package.json';
export const packageVersion = packageJson.version;

export const environment = {
  production: true,
  dashboardVersion: packageVersion,
  baseEncryptionKey: 'VbxDwQxfmQHVeFP0F9Wk5qUjE0YjRUv1',
  useRecaptcha: true,
};
